export class MapTabEvents {

    // eslint-disable-next-line sonarjs/public-static-readonly
    static TabChanged = "TabChanged";
}
